module.exports = __webpack_public_path__ + "static/IBMPlexMono400-0a25c96eb36d640fe49af50fd28f3930.woff2";